<template>
  <div class="content">
    <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar title="充值记录" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="hint" v-if="carList.length == '0'">
      <img
        src="https://account.kmmds.top/datainfo_pic/error.png"
        alt=""
        srcset=""
      />
      <div style="color:#999">暂 无 充 值 信 息</div>
    </div>
    <div v-else class="record_box">
      <div class="record" v-for="(item, index) in carList" :key="index">
        <div class="record_card">
          <div class="top">
            <div class="amount">充值金额</div>
            <div class="times">￥ {{item.prePayCost}}</div>
          </div>
          <div class="top">
            <div class="amount">患者名</div>
            <div class="times">{{item.clientName}}</div>
          </div>
          <div class="top">
            <div class="amount">虚拟发票号</div>
            <div class="times">{{item.invoiceNo}}</div>
          </div>
           <div class="top">
            <div class="amount">付款方式</div>
            <div class="times">{{item.channel}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="payBtn" @click="payBtn">充值</div>
  </div>
</template>


<script>
import Nav from "../ElectronicHealthCard/components/nav.vue";
export default {
  data() {
    return {
      carList: [
      ],
      clientId: "",
      InPatientId: "",
      clientName: "",
      deptId: "",
    };
  },
  mounted() {
    this.clientId = this.$route.query.clientId;
    this.InPatientId = this.$route.query.InPatientId;
    this.clientName = this.$route.query.clientName;
    this.deptId = this.$route.query.deptId;
    this.getranklist()
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/prehistorylist",
        query: {
          clientId: this.clientId,
          name: this.clientName,
        },
      });
    },
  async getranklist(){
    try {
        this.$showLoad();
        let url = "/outpatientfee/queryinpatientrechargerecord";
        let data={
          inPatientId:this.InPatientId
        }
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            this.carList = data.data.data.data;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
  },
    // 充值页面跳转按钮
    payBtn() {
      this.$router.push({
        path: "/pay",
        query: {
          clientId: this.clientId,
          InPatientId: this.InPatientId,
          clientName: this.clientName,
          deptId: this.deptId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .record_box {
    height: 550px;
    margin-top: 5px;
    overflow-y: scroll;
    .record {
      width: 95vw;
      margin: 0 auto;
      margin-top: 15px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);

      .record_card {
        width: 90vw;
        margin: 0 auto;
        font-size: 16px;

        .top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 90vw;

          .amount {
            text-align: left;
            line-height: 5vh;
           color: #999;
          }
          .times {
            color: #999;
            line-height: 5vh;
            color: #999;
          }
        }
      }
    }
  }

  .payBtn {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    height: 50px;
    border-radius: 15px;
    width: 90%;
    margin: 0 auto;
    background-color: #5b8df6;
  }
}
</style>